import { useEffect } from "react";
import { ensureAuthHydrated } from "./auth/authApi";
import { loadCategoryItems } from "./services/csvCardCatalog";

/**
 * Runs once on app load: hydrate PocketBase auth and warm the CSV card cache
 * in parallel so Home / Profile favorite resolution does not wait on cold fetches.
 */
export default function AuthBootstrap() {
  useEffect(() => {
    ensureAuthHydrated().catch(() => {});
    Promise.all(
      ["TOOLS", "RESOS", "IDEAZ", "APPS"].map((c) => loadCategoryItems(c))
    ).catch(() => {});
  }, []);
  return null;
}
